function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(3.744 3.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M422.617,90.261c20.452-35.613,27.8-82.761,27.8-82.761l13.15.05S457.081,64.978,443,98.818l-15.309,4.916Z",
  transform: "translate(-215.051 -7.5)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M212,169.774l23.459,9.849a8.486,8.486,0,0,1,4.806,10.41c-8.34,26.027-42.1,112.731-129.185,142.29-23.847,8.095-56.24,6.616-79.845-15.73C8.556,295.126,5.942,263.81,8.138,240.1a30.137,30.137,0,0,1,35.585-26.8c45.138,8.524,114.757,12.308,158.453-41.051A8.459,8.459,0,0,1,212,169.774Z",
  transform: "translate(-7.508 -88.306)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(66.15 80.815)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M301.6,179.624l-23.459-9.849a8.459,8.459,0,0,0-9.82,2.482c-.368.45-.742.884-1.114,1.326l14.391,6.042a8.485,8.485,0,0,1,4.806,10.41c-8.34,26.027-42.1,112.731-129.185,142.29a85.335,85.335,0,0,1-17.416,3.905,85.882,85.882,0,0,0,37.417-3.905C264.3,302.765,298.063,216.061,306.4,190.034A8.486,8.486,0,0,0,301.6,179.624Z",
  transform: "translate(-139.8 -169.121)",
  fill: "rgba(147,147,147,0.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(19.353 102.412)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M105.085,413.761c-26.8-.1-45.69-15.3-54.082-32.941a60.358,60.358,0,0,1-4.661-14.377,6.974,6.974,0,0,1,7.923-8.193c30.689,4.714,67.684,7.76,96.851,1.334,12.825-2.826,25.192,7.775,30.6,13.285a4.274,4.274,0,0,1-.074,6.091c-16.35,15.545-51.984,34.9-76.558,34.8Z",
  transform: "translate(-46.212 -285.235)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M206.448,275.678c10.968-14.06,27.712-37.046,34.122-53.941a6.941,6.941,0,0,0-11.709-7.049C217.6,227.623,169.8,272.826,63.191,255.639a7.52,7.52,0,0,0-2.545,14.823c15.621,2.77,54.751,8.246,93.579,2.108a36.868,36.868,0,0,1,25.479,5.2l3.171,2A17.82,17.82,0,0,0,206.448,275.678Z",
  transform: "translate(-50.327 -212.313)",
  fill: "rgba(147,147,147,0.69)"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M255.081,1.307A3.751,3.751,0,0,0,252.294.05L239.144,0h-.014a3.75,3.75,0,0,0-3.705,3.173c-.07.452-7.068,44.339-25.732,78.584a12.136,12.136,0,0,0-14.161,3.568c-18.773,22.924-44.474,37.191-76.389,42.406-22.894,3.741-49.294,2.845-78.466-2.665C21.327,121.413,2.472,135.633.66,155.2c-2.2,23.741.225,56.816,24.249,79.56,16.454,15.577,36.4,21.27,54.795,21.269a90.607,90.607,0,0,0,28.834-4.711c88.69-30.105,123.113-118.363,131.551-144.7a12.152,12.152,0,0,0-3.733-13.062A260.184,260.184,0,0,0,247,57.006c1.064-4.73-6.254-6.377-7.318-1.646a256.419,256.419,0,0,1-10.042,34.773l-13-5.457c16.288-30.191,23.683-66.294,25.645-77.163l5.748.022c-.762,5.877-2.373,17.4-4.859,30.751-.888,4.767,6.486,6.14,7.373,1.373C254.2,20.1,255.989,4.379,256.006,4.222a3.752,3.752,0,0,0-.925-2.915ZM232.946,104.334c-8.167,25.489-41.45,110.9-126.819,139.883-21.464,7.286-52.717,7.2-76.061-14.9C8.23,208.642,6.084,177.976,8.129,155.892a26.678,26.678,0,0,1,31.155-23.455c30.032,5.672,57.307,6.579,81.067,2.7,33.772-5.518,61.019-20.678,80.983-45.056a4.687,4.687,0,0,1,5.466-1.4l23.459,9.849a4.71,4.71,0,0,1,2.687,5.808Z",
  transform: "translate(-0.021 0)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M146.57,352.178c-23.579,5.195-55.7,4.731-95.475-1.379A10.879,10.879,0,0,0,38.92,363.412a63.791,63.791,0,0,0,4.956,15.275c10.479,22.03,33.543,35.081,57.638,35.081,11.706,0,26.9-4.226,42.824-11.91,13.971-6.743,27.485-15.687,36.149-23.925a8.093,8.093,0,0,0,.167-11.436c-15.329-15.616-27.935-15.674-34.084-14.319Zm28.75,20.32c-8.131,7.731-20.932,16.182-34.242,22.606-14.923,7.2-28.962,11.164-39.558,11.164-21.232,0-41.621-11.358-50.87-30.8a56.246,56.246,0,0,1-4.366-13.478q-.128-3.779,3.672-3.775c40.692,6.25,73.74,6.685,98.227,1.29,11.2-2.467,22.7,7.744,27.119,12.25A.525.525,0,0,1,175.32,372.5Z",
  transform: "translate(-19.376 -175.329)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M233.544,205.209a10.734,10.734,0,0,0-10.922,3.272C212.629,219.965,173.429,257,88.553,251.424c-4.839-.311-5.33,7.166-.492,7.484q9.048.595,17.436.583c76.374,0,112.939-34.774,122.784-46.087,2.2-2.532,6.647-.1,5.374,3.257-6.382,16.82-23.774,40.4-33.573,52.965-5.766,7.391-14.937,5.956-21.784,1.23a40.617,40.617,0,0,0-28.068-5.734c-38.42,6.073-77.374.557-92.339-2.1-4.762-.845-3.517-8.2,1.293-7.428,3.184.513,6.39.983,9.529,1.4,4.807.627,5.785-6.805.977-7.436-3.067-.4-6.2-.862-9.312-1.363-14.249-2.3-18,19.7-3.8,22.218,15.337,2.72,55.278,8.37,94.819,2.12a33.116,33.116,0,0,1,22.889,4.666c10.188,6.876,23.5,7.557,31.706-2.956,12.287-15.751,28.277-38.064,34.672-54.917a10.859,10.859,0,0,0-7.122-14.114Z",
  transform: "translate(-23.821 -102.405)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgChop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.008,
    height: 256.03,
    viewBox: "0 0 256.008 256.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChop);
export default __webpack_public_path__ + "static/media/chop.fe2f2951.svg";
export { ForwardRef as ReactComponent };